const GLOSSARY_NAME_FORBIDDEN_CHARACTER_PATTERN = /[./\\"><]/;
const GLOSSARY_NAME_FORBIDDEN_SEQUENCE_PATTERN = /::/;
const DELETE_CHARACTER_CODE = 0x7f;

const hasForbiddenControlCharacters = (value: string): boolean =>
  Array.from(value).some((char) => {
    const code = char.charCodeAt(0);
    return code <= 0x1f || code === DELETE_CHARACTER_CODE;
  });

export const GLOSSARY_NAME_INVALID_MESSAGE = '이름에는 ., ::, /, \\, ", <, >, 줄바꿈 및 제어문자를 사용할 수 없습니다';

export const normalizeGlossaryName = (value: string): string => value.trim().replace(/ {2,}/g, ' ');

export const hasInvalidGlossaryNameCharacters = (value: string): boolean =>
  GLOSSARY_NAME_FORBIDDEN_SEQUENCE_PATTERN.test(value) ||
  GLOSSARY_NAME_FORBIDDEN_CHARACTER_PATTERN.test(value) ||
  hasForbiddenControlCharacters(value);

export const validateGlossaryName = (value: string): boolean => {
  if (!value) {
    return true;
  }

  const normalizedValue = normalizeGlossaryName(value);
  if (!normalizedValue) {
    return false;
  }

  return !hasInvalidGlossaryNameCharacters(value);
};
